var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditGryIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81366 14.6899L13.1357 5.2212C13.5336 4.71059 13.6751 4.12025 13.5424 3.51916C13.4275 2.97271 13.0914 2.45314 12.5874 2.05899L11.3582 1.08255C10.2882 0.231533 8.96177 0.321114 8.20127 1.29755L7.37887 2.36446C7.27276 2.49793 7.29929 2.69501 7.43193 2.80251C7.43193 2.80251 9.51003 4.46872 9.55424 4.50455C9.69573 4.63892 9.80185 4.81808 9.82838 5.03308C9.87259 5.45411 9.58077 5.84827 9.14747 5.90201C8.94408 5.92889 8.74953 5.86618 8.60805 5.74973L6.42383 4.01185C6.31771 3.93213 6.15854 3.94915 6.07011 4.05664L0.879282 10.7752C0.543249 11.1963 0.42829 11.7427 0.543249 12.2712L1.20647 15.1468C1.24184 15.2991 1.37449 15.4066 1.53366 15.4066L4.45185 15.3707C4.98242 15.3618 5.47763 15.1199 5.81366 14.6899ZM9.89974 13.7944H14.6581C15.1224 13.7944 15.5 14.1769 15.5 14.6472C15.5 15.1184 15.1224 15.5 14.6581 15.5H9.89974C9.43548 15.5 9.05789 15.1184 9.05789 14.6472C9.05789 14.1769 9.43548 13.7944 9.89974 13.7944Z",
    fill: "#aFaFaF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditGryIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditGryIcon.10ad2946.svg";
export { ForwardRef as ReactComponent };